module.exports = __webpack_public_path__ + "img/154.f2f0b4d7.jpg";